<template>
  <div>
    <v-app-bar app clipped-left flat dark height="66px" class="mobileAppBar">
      <v-app-bar-nav-icon
        class="mobileAppBarButton"
        @click="openDrawer()"
      ></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer app fixed temporary v-model="drawer">
      <div class="nav-logo clickable" @click="goTo('Home')">
        <CImage
          :url="logo"
          :square="false"
          :alt="'Foncier Public.com'"
        ></CImage>
      </div>
      <div>
        <v-row no-gutters align="center" justify="center">
          <v-col cols="12">
            <v-btn
              class="nav-btn"
              @click="goTo('Home')"
              target="_blank"
              text
              tile
              depressed
            >
              <span class="mr-2 blue_10--text regular-app-bar">Accueil</span>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="nav-btn"
              @click="goTo('SearchView')"
              target="_blank"
              color="secondary"
              tile
              depressed
            >
              <span class="mr-2 blue_10--text regular-app-bar"
                >Espace locataire</span
              >
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="nav-btn"
              @click="goTo('Proprietaire')"
              target="_blank"
              color="tertiary"
              tile
              depressed
            >
              <span class="mr-2 greekblue_10--text regular-app-bar"
                >Espace propriétaire</span
              >
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn
              v-if="!this.haveUser"
              class="nav-btn"
              target="_blank"
              color="transparent"
              tile
              block
              depressed
            >
              <span
                class="mr-2 grey_10--text regular-app-bar"
                @click="goTo('Connection')"
              >
                Inscription /
                <br />Connexion
              </span>
              <Icon
                type="plus-circle"
                style="color:--var(grey_10); fontSize:21px"
              />
            </v-btn>
            <v-btn
              v-else
              class="nav-btn"
              target="_blank"
              color="transparent"
              tile
              block
              depressed
            >
              <span class="mr-2 grey_10--text regular-app-bar" @click="logOut"
                >Déconnexion</span
              >
              <Icon type="logout" style="color:--var(grey_10); fontSize:21px" />
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import CImage from "@/components/HomeSections/SubComponents/Image";
import { Icon } from "ant-design-vue";
import { mapGetters } from "vuex";
import { logOut } from "@/services/user";

export default {
  name: "NavigationDrawer",
  components: {
    CImage,
    Icon
  },
  data() {
    return {
      drawer: false,
      logo: "logo_foncier-public3-cutted.png"
    };
  },
  methods: {
    openDrawer() {
      this.drawer = !this.drawer;
    },
    goTo(name) {
      this.redirect(name);
    },
    logOut() {
      logOut();
    }
  },

  computed: {
    ...mapGetters({
      haveUser: "userModule/haveUser"
    })
  }
};
</script>

<style scoped>
.mobileAppBar {
  background: transparent !important;
  z-index: 1337 !important;
}

.mobileAppBarButton {
  background: #62d4d2;
  color: #fff;
}
.nav-logo {
  margin-left: 35px;
  min-height: 56px;
  min-width: 100px;
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin-right: 1rem;
  margin-top: 66px;
}

.nav-btns {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  height: 100%;
}

.nav-btn {
  height: 4em !important;
  width: 100%;
  text-transform: none !important;
}

.nav-btn-rounded {
  border-radius: 0px 0px 0px 48px !important;
}
</style>
